// Generated by pnpm narration:generate from narrationConfig.json.
export { default } from '../../public/narration/developer/primitive/en-US-Neural2-J/manifest.json';
